import React, { useEffect, useMemo } from 'react';
import { Alert } from 'antd';
import {
  useFormMethods,
  useFormWatch,
} from '../../../../helpers/formManager';
import {
  fieldNames,
  fieldPathBuilders,
} from '../../shared/configs/acceptanceForm';
import { getOverlappingAcceptances } from './utils';
import { formatDate } from '../../shared/packages/dateTime';
import { useDeskOccupiedDateRanges } from '../../api/deskOccupiedDateRanges';
import { useSearchParamsMethods } from '../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../shared/configs/searchParams';
import { parseAcceptanceSlug } from '../../shared/packages/acceptance';
import styles from './index.module.scss';

const DeskOccupiedPeriods = ({ deskIndex, queryEnabled }) => {
  const [deskId, fromDate, toDate] = useFormWatch({
    name: [
      `${fieldPathBuilders.desk.name(deskIndex)}.key`,
      fieldNames.main.fromDate,
      fieldNames.main.toDate,
    ],
  });

  const { setError, clearErrors } = useFormMethods();

  const { getParams } = useSearchParamsMethods();

  const { data } = useDeskOccupiedDateRanges({
    params: { deskId },
    options: { enabled: Boolean(deskId) && queryEnabled },
  });

  const occupiedAcceptances = useMemo(() => {
    const acceptanceSlug = getParams(searchParamKeys.acceptance);

    const { acceptanceId } = parseAcceptanceSlug(acceptanceSlug);

    return getOverlappingAcceptances(data, fromDate, toDate, acceptanceId);
  }, [data, fromDate, toDate, getParams]);

  useEffect(() => {
    const name = `${fieldPathBuilders.desk.byIndex(deskIndex)}.ocuppied`;

    occupiedAcceptances
      ? setError(name, { type: 'occupied' })
      : clearErrors(name);
  }, [occupiedAcceptances, setError, clearErrors, deskIndex]);

  return occupiedAcceptances ? (
    <Alert
      message={`Внимание! Идет пересечение с ${
        occupiedAcceptances.length === 1 ? 'приемкой' : 'приемками'
      }`}
      description={<Description occupiedAcceptances={occupiedAcceptances} />}
      type="error"
    />
  ) : null;
};

export default DeskOccupiedPeriods;

function Description({ occupiedAcceptances }) {
  return (
    <ul className={styles.list}>
      {occupiedAcceptances.map((item) => (
        <li key={item.id}>
          <span className={styles.name}>{item.name}:</span>{' '}
          <span>{formatDate(item.fromDate)}</span> —{' '}
          <span>{formatDate(item.toDate)}</span>
        </li>
      ))}
    </ul>
  );
}
